// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f
'use es6';

import { createSelector } from 'reselect';
import { getCurrentThreadLatestContextUpdateMessage } from '../../unified-thread-history/selectors/getCurrentThreadLatestContextUpdateMessage';
import { getId, getChatflowContext } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
export const getCurrentChatflowId = createSelector([getCurrentThreadLatestContextUpdateMessage], contextUpdateMessage => {
  return getId(getChatflowContext(contextUpdateMessage));
});